import React from 'react';
import { Box, styled } from '@mui/material';
import PageHeader from '../../../../atoms/header/PageHeader';
import Title from '../../../../atoms/title/Title';
import { routes } from '../../../../routes/routes';
import AddToRoleModal from '../../../modals/Statement/AddToRoleModal';

const StyledTitlesWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

const StatementHeader = () => {
  return (
    <PageHeader>
      <AddToRoleModal />
      <StyledTitlesWrapper>
        <Title text={routes.company.statements.name} />
      </StyledTitlesWrapper>
    </PageHeader>
  );
};

export default StatementHeader;
